const filterTable = (array) => {
  return array && array?.filter((el) => el !== false);
};

export default filterTable;
